import { render, staticRenderFns } from "./MaterialsServicesMaintenance.vue?vue&type=template&id=10ffb018&"
import script from "./MaterialsServicesMaintenance.vue?vue&type=script&lang=js&"
export * from "./MaterialsServicesMaintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10ffb018')) {
      api.createRecord('10ffb018', component.options)
    } else {
      api.reload('10ffb018', component.options)
    }
    module.hot.accept("./MaterialsServicesMaintenance.vue?vue&type=template&id=10ffb018&", function () {
      api.rerender('10ffb018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/materialsRequests/components/MaterialsServicesMaintenance.vue"
export default component.exports